import { Skeleton } from "antd";

export const BookSliderSkeleton = ({
  title,
  height,
}: {
  title: string;
  height?: string;
}) => (
  <div className="mb-8">
    {/* Title skeleton */}
    <div className="h-6 w-[45%] mb-4 animate-pulse bg-gray-300 dark:bg-gray-700 rounded text-gray-700 dark:text-gray-300">
      {title || ""}
    </div>

    {/* Books skeleton */}
    <div className="flex gap-4">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className={
            "h-" +
            (height || 64) +
            " w-[32%] animate-pulse bg-gray-300 dark:bg-gray-700 rounded-lg"
          }
        />
      ))}
    </div>
  </div>
);
